/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Dashboard_Order_Status_Filter_HintInputs */

const vi_dashboard_order_status_filter_hint = /** @type {(inputs: Dashboard_Order_Status_Filter_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xem đơn hàng: ${i?.status}`)
};

/**

* @param {Dashboard_Order_Status_Filter_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_order_status_filter_hint = /** @type {((inputs: Dashboard_Order_Status_Filter_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Order_Status_Filter_HintInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_order_status_filter_hint(inputs)
});